import styled from 'styled-components';

export const ButtonBriefing = styled.button`
	font-family: Poppins, Heltica, Arial, sans-serif;
	border-radius: 4px;
	background-color: transparent;
	color: #00BDCE;
	font-size: 14px;
	margin-left: 5px;
	border:  1px solid #00BDCE;
    transition: all .3s ease-in-out;
	float: right;
	min-width: 128.88px;

	&:hover {
		background-color: transparent;
		color:#00BDCE;
		border: 1px solid #00BDCE;
	}

	&:focus {
		outline: 0;
	}
`;
